import {
  getAllUserInfo,
  getUserInfoRequest,
  requestAddAgentUser,
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求

const state = {}

const getters = {}

const actions = {
  async getUserInfo ({commit}, params) {
    return getUserInfoRequest(getUrl(params)).then(response => response)
  },
  async addAgentUser ({commit}, params) {
    return requestAddAgentUser(params).then(response => response)
  },
  async getAllUserInfo ({commit}, params) {
    return getAllUserInfo(getUrl(params)).then(response => response)
  }
};

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userinfo/userinfo.js